<template lang="html">
	<div 
		class="form-group" 
		v-if="form">
		<label :for="randomId">{{ label }}</label>
		<input 
			:id="randomId" 
			type="text" 
			class="form-control input-sm" 
			:value="value" 
			:placeholder="placeholder" 
			@input="onInput" 
			:disabled="disabled" 
			:name="name">
	</div>
	<div 
		v-else-if="action" 
		class="input-group input-group-sm">
		<input 
			type="text" 
			:id="randomId" 
			:value="value" 
			:placeholder="placeholder" 
			@input="onInput" 
			class="form-control input-sm" 
			:disabled="disabled" 
			:name="name">
		<span class="input-group-btn">
			<button 
				@click="buttonPress" 
				class="btn btn-default">{{ buttonLabel }}</button>
		</span>
	</div>
	<input 
		v-else 
		:id="randomId" 
		type="text" 
		class="form-control input-sm" 
		:value="value" 
		:placeholder="placeholder" 
		@input="onInput" 
		:disabled="disabled" 
		:name="name">
</template>

<script>
export default {
	name: 'InputText',
	data() {
		return {
			randomId: 'input-' + Math.random()
		}
	},
	props: [
		'label',
		'value',
		'form',
		'action',
		'buttonLabel',
		'placeholder',
		'disabled',
		'label'
	],
	methods: {
		onInput(event) {
			this.$emit('input', event.target.value.trim())
		},
		buttonPress() {
			this.$emit(this.action)
		}
	}
}
</script>

<style lang="css">
</style>
